<script setup lang="ts">
interface Emits {
  (e: 'confirm'): void
  (e: 'cancel'): void
}

defineEmits<Emits>()

defineProps<{
  isOpen: boolean
}>()
</script>

<template>
  <div v-if="isOpen" class="logout-overlay" @click="$emit('cancel')">
    <div class="logout-dialog" @click.stop>
      <div class="logout-message">確定登出？</div>

      <div class="logout-actions">
        <button class="logout-btn cancel-btn" @click="$emit('cancel')">取消</button>
        <button class="logout-btn confirm-btn" @click="$emit('confirm')">確定</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.logout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 350;
}

.logout-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  padding: 24px;
  max-width: 300px;
}

.logout-message {
  font-size: 16px;
  margin-bottom: 20px;
  color: #1f2937;
  font-weight: 500;
}

.logout-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.logout-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.cancel-btn {
  background: #f3f4f6;
  color: #6b7280;
}

.cancel-btn:hover {
  background: #e5e7eb;
}

.confirm-btn {
  background: #ef4444;
  color: white;
}

.confirm-btn:hover {
  background: #dc2626;
}
</style>
